import React from 'react'
import { SvgIcon, SvgIconProps } from '@hermes/web-components'

const defaultColor = '#2C3341'

const ContactChatIcon = ({ color, ...props }: SvgIconProps) => (
  <SvgIcon width="28" height="29" viewBox="0 0 28 29" {...props}>
    <path
      d="M4.66671 3.58167H16.3334C16.9522 3.58167 17.5457 3.8275 17.9833 4.26508C18.4209 4.70267 18.6667 5.29616 18.6667 5.915V12.915C18.6667 13.5338 18.4209 14.1273 17.9833 14.5649C17.5457 15.0025 16.9522 15.2483 16.3334 15.2483H12.8334L9.33337 18.7483L5.83337 15.2483H4.66671C4.04787 15.2483 3.45438 15.0025 3.01679 14.5649C2.57921 14.1273 2.33337 13.5338 2.33337 12.915V5.915C2.33337 5.29616 2.57921 4.70267 3.01679 4.26508C3.45438 3.8275 4.04787 3.58167 4.66671 3.58167Z"
      stroke={color || defaultColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="transparent"
    />
    <path
      d="M18.6667 9.41504H23.3334C23.9522 9.41504 24.5457 9.66087 24.9833 10.0985C25.4209 10.536 25.6667 11.1295 25.6667 11.7484V18.7484C25.6667 19.3672 25.4209 19.9607 24.9833 20.3983C24.5457 20.8359 23.9522 21.0817 23.3334 21.0817H21L18.6667 24.5817L15.1667 21.0817H11.6667C11.0479 21.0817 10.4544 20.8359 10.0168 20.3983C9.57921 19.9607 9.33337 19.3672 9.33337 18.7484"
      stroke={color || defaultColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="transparent"
    />
  </SvgIcon>
)

export default ContactChatIcon
